import { hasRoleClaim, type JwtClaims } from "@pgs-core/portal-lib/claims";

export * from "@pgs-core/portal-lib/claims";

export function hasAdminRoleClaim(claims: JwtClaims): boolean {
  return hasRoleClaim(claims, "admin");
}
